var url_array = script_url.split('/assets/');
var asset_url = url_array[0]+'/assets/';
var url_version_array = url_array[1].split('?');
var asset_version = '?'+url_version_array[1];

var ouatineNewsletterPopup = getCookie('newsletterpopupview');
var newsletterPopupView = (ouatineNewsletterPopup != "") ? true : false;


$(document).ready(function(){
  
  // add scrolled class to body on scroll
  $(window).on('scroll', function(){
    if ($(window).scrollTop() > 25) {
		$('body').addClass('scrolled');
    } else {
		$('body').removeClass('scrolled');
    }
  }).scroll();
  
  /*
  // home-slider
  $('.home-slider').slick({
    autoplay: true,
    autoplaySpeed: 4500,
    arrows: false,
    dots: true
  });
  */
  
  /*
  // On after slide change
  $('.home-slider').on('afterChange', function(event, slick, currentSlide){
    var classes = ['home-products', 'home-values', 'home-advices'];
    $('body').removeClass('home-products home-values home-advices').addClass(classes[currentSlide]);
  });
  */

  
  // product-slider
  $('.product-slider').slick({
    responsive: true,
    respondTo: 'min',
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.product-slider-nav'
  });
  $('.product-slider-nav').slick({
    slidesToShow: 5,
    asNavFor: '.product-slider',
    dots: false,
    //centerMode: true,
    focusOnSelect: true
  });

  // related-slider
  $('.related-slider').slick({
    arrows: false,
    dots: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: true,
    respondTo: 'min'
  });


  $('.zoom-wrapper').zoom();
  /*
  $('.img-zoom-link').on('mouseup', function(e){
    var zoomSrc = $(this).data('zoom');

    $('#imgZoomModal .modal-body').html('<img src="'+zoomSrc+'" alt="" class="img-fluid rounded-lg" />');
    $('#imgZoomModal').modal('show');
  });

  $('#imgZoomModal').on('hidden.bs.modal', function(e) {
    $('#imgZoomModal .modal-body').empty();
  });
  */
  
  // Multi-purpose modal cleaning
  $('#multiPurposeModal').on('hidden.bs.modal', function(e) {
    $('#multiPurposeModal .modal-body-content').empty();
  });
  
  // Product option selector TOP/BOTTOM sync
  $('.product-options-form .option-selector').on('change', function(e){
    var thisForm = $(this).parents('.product-options-form');
    var otherForm = (thisForm.hasClass('product-options-form-top')) ? $('.product-options-form-bottom') : $('.product-options-form-top');
    var thisVal = $(this).val();
    var thisId = $(this).attr('id');
    $('#'+thisId, otherForm).val(thisVal);
  });
  
  // video inline players
  const players = Plyr.setup('.inline-plyr');
  
  $('.video-modal-link-plyr').on('click', function(e){
    e.preventDefault();
    
    var videoSrc = $(this).attr('href');
    
    $('#multiPurposeModal .modal-body-content').html('<video poster="'+asset_url+'ouatine-video-poster.jpg'+asset_version+'" id="player" playsinline controls><source src="'+videoSrc+'" type="video/mp4" /></video>');
    
    var player = new Plyr('#player');
    
    $('#multiPurposeModal').modal('show');
  });
  
  /* add to basket num */
  $('.product-less, .product-more').on('click', function(e){
    e.preventDefault();

    var thisNum = $(this).parents('.prod-num-container').find('input[type=number]');
    var num = parseInt(thisNum.val());
    //console.log(num);
    if ($(this).hasClass('product-less')){
      if (num > 1) num--;
      else num = 1;
    } else {
      num++;
    }
    thisNum.val(num);
  });

  /* activate click on select arrow */
  $('.product-options-form select::after').on('click', function(){
    log($(this).prev('select'));
    //$(this).prev('select').focus().click();
  });
  
  /* date pickers defaults */
  $('.datepicker').datepicker({
    language: 'fr',
    format: 'dd/mm/yyyy'
  });
  
  /* Newsletter popup */
  var newsletterTimeout = setTimeout(function(){
    if (!newsletterPopupView) $('#newsletterModal').modal('show');
  }, 60000);
  
  $('#newsletterModal').on('shown.bs.modal', function(e) {
    clearTimeout(newsletterTimeout);
    setCookie('newsletterpopupview', 1, 7);
  });

  $('#newsletterModal').on('hidden.bs.modal', function(e) {
    $('#newsletterModal form')[0].reset();
  });

  // display popup if form has been submitted
  var formPosted = getUrlParameter('customer_posted');
  if (formPosted == 'true') {
    $('#newsletterModal').modal('show');
  }

});

/* FUNCTIONS */

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
}